import { ReactNode, useRef } from 'react';
import Vec2 from 'vec2';

import { useDrawingShapeContext } from '../drawingShapeContext';
import { FabricCanvasContext } from './fabricCanvas.context';
import { Position } from './fabricCanvas.types';
import { useDrawFabricCanvas, useFreeDrawHandler } from './hooks';

import { DRAGGING_STATE } from '~/core/enums';
import { DrawingTabEnum } from '~/core/enums/drawing-tab.enum';
import { DrawingShape } from '~/core/models';

export const FabricCanvasProvider = ({
  children,
}: {
  children?: ReactNode;
}): JSX.Element => {
  const drawingShapesRef = useRef<DrawingShape[]>([]);
  const draggingStateRef = useRef<DRAGGING_STATE>(DRAGGING_STATE.IDLE);
  const isShapeLogicRef = useRef(true);
  const lastPositionRef = useRef<Position>({});
  const movingItemRef = useRef<DrawingShape | string | undefined>(undefined);
  const selectedDrawingTabRef = useRef<DrawingTabEnum>();
  const shapeStartDragRef = useRef<Vec2>(new Vec2(0, 0));

  const {
    getters: { drawingShapes },
  } = useDrawingShapeContext();

  useFreeDrawHandler();

  drawingShapesRef.current = drawingShapes;

  useDrawFabricCanvas();

  const contextValue = {
    draggingStateRef,
    drawingShapesRef,
    isShapeLogicRef,
    lastPositionRef,
    movingItemRef,
    selectedDrawingTabRef,
    shapeStartDragRef,
  };

  return (
    <FabricCanvasContext.Provider value={contextValue}>
      {children}
    </FabricCanvasContext.Provider>
  );
};
